import { authUtils } from '@/utils';
import { loginApis } from '@/api';
import routerCategoryMap from '@/router/routerCategoryMap';

const user = {
    name: 'user',
    namespaced: true,
    state: {
        // cdnHost
        cdnHost: '',
        token: authUtils.getToken(),

        // 用户信息: { id, phone, hasPassword, roles,  , orgs, ... }
        userInfo: {},
        // 用户组织类型STORE CORPORATION
        userOrgsType: 'STORE',
        // 用户菜单权限树
        userMenuTree: [],
        // 系统模块信息
        moduleList: [],
        // userInfo只会获取一次接口，标记判断
        isGetUserInfo: false,

        // 用户菜单列表
        userMenuList: [],
        // orgs: tags为 "STORE"的的orgList
        orgList: [],
        // groupOrgs:全量
        groupOrgList: [],
        // 登录后未检查版本更新
        isCheck: null,
    },
    getters: {
        /**
         * 获取页面内按钮权限
         * @param route: 'Homepage'                    // 页面路由名
         * @param button: 'Create/Read/Update/Delete'  // 按钮名
         * 新增：不需要按钮名的菜单--碰撞救援统计模块getAuthority('CollisionRescueStatistics')
         */
        getAuthority: state => (route, button, isHidden = false) => {
            const myHidden = isHidden;
            // if (!route || !button) return false;
            if (!route) return false;

            let flag = false;
            // 根据name查找节点
            function searchNode(nodeList, name) {
                let resNode = null;
                nodeList.some((node) => {
                    if (node.name === name) {
                        resNode = node;
                        return true;
                    }
                    // 前面的循环没有找到才继续向下找
                    if (!resNode) resNode = searchNode(node.children || [], name);
                    return false;
                });
                return resNode;
            }
            const routeNode = searchNode(state.userMenuTree, route);
            if (button) {
                if (routeNode && routeNode.children && routeNode.children.length) {
                    flag = routeNode.children.some(v => v.name === button);
                }
            } else {
                flag = routeNode.auth;
            }
            // 获取页面内按钮是否存在
            if (myHidden && state.userInfo.mode !== 2) {
                return true;
                // return flag;
            }
            return flag;
        },
        // /**
        //  * 获取页面内按钮是否存在
        //  * @param route: 'Homepage'                    // 页面路由名
        //  * @param button: 'Create/Read/Update/Delete'  // 按钮名
        //  */
        // getBtnExist: state => (route, button) => {
        //     if (state.userInfo.mode !== 2) return true;

        //     return state.getters.getAuthority(route, button);
        // },

    },
    actions: {
        // 获取图片cdnHost
        // async getCdnHost({ commit }, params) {
        //     const res = await oss.downloadFile(params);
        //     commit('SET_CDNHOST', res);
        //     authUtils.setToken(data.ticket);
        // },
        // 手机号登录
        async LoginByPhone({ commit }, params) {
            try {
                const { data } = await loginApis.loginByPhone(params);
                commit('SET_STATE', { token: data.ticket });
                authUtils.setToken(data.ticket);
            } catch (err) {
                throw new Error(err);
            }
        },

        // 用户名登录
        async LoginByUsername({ commit }, params) {
            try {
                const { data } = await loginApis.loginByUsername(params);
                commit('SET_STATE', { token: data.ticket });
                authUtils.setToken(data.ticket);
            } catch (err) {
                throw new Error(err);
            }
        },

        // 扫码登录保存token
        SetToken({ commit }, data) {
            commit('SET_STATE', { token: data.ticket });
            authUtils.setToken(data.ticket);
        },

        // 获取用户信息
        async GetUserInfo({ commit }) {
            try {
                const { data: userInfo = {} } = await loginApis.getUserInfo();
                console.log(userInfo);

                // 登录后已选取组织，才能继续获取菜单
                if (userInfo.mode === 1 && ((!userInfo.lastLoginOrgId && userInfo.lastLoginOrgId !== 0) || !userInfo.orgType)) {
                    // eslint-disable-next-line
                    throw '组织标签错误！';
                }

                const {
                    data: {
                        list = [
                            { children: [] },
                        ],
                    },
                } = await loginApis.getUserMenu({
                    userId: userInfo.id,
                    orgId: userInfo.lastLoginOrgId,
                });
                let userMenuTree = [];
                const moduleList = [];
                list[0].children.forEach((val) => {
                    moduleList.push(val);
                    if (val.type !== 'MODULE') {
                        userMenuTree.push(val);
                        return;
                    }
                    if (val.children) {
                        userMenuTree = userMenuTree.concat(val.children);
                    }
                });
                // const userMenuTree = [
                //     ...list[0].children,
                // ];
                // 上一次选择的模式
                userInfo.mode = userInfo.lastLoginMode;
                // 过滤orgList
                let orgList = [];
                orgList = userInfo.orgs.filter((item) => {
                    const myItem = item;
                    myItem.label = item.orgName;
                    myItem.value = item.orgId;
                    return item.orgType === 'STORE';
                });

                // 增加筛选用的key 此处不过滤 groupOrgList（用户管理/权限管理  要用全量数据）
                let groupOrgList = [];
                groupOrgList = userInfo.orgs && userInfo.orgs.filter((item) => {
                    const myItem = item;
                    myItem.label = item.orgName;
                    myItem.value = item.orgId;
                    return true;
                });

                // 模式类型
                const { lastLoginMode } = userInfo;
                let userOrgsType = 'STORE';
                if (lastLoginMode === 1 || lastLoginMode === 2) {
                    userOrgsType = 'STORE';
                } else {
                    userOrgsType = 'CORPORATION';
                }

                commit('SET_STATE', {
                    userInfo,
                    userMenuTree,
                    moduleList,
                    isGetUserInfo: true,
                    orgList,
                    groupOrgList,
                    userOrgsType,
                });
            } catch (err) {
                throw new Error(err);
            }
        },
        // 修改用户组织类型
        resetUserOrgsType({ commit }, userOrgsType) {
            commit('SET_STATE', {
                userOrgsType,
            });
        },
        // 修改用户姓名
        resetUserInfo({ commit }, userInfo) {
            commit('SET_STATE', {
                userInfo,
            });
        },
        setIsCheck({ commit }, isCheck) {
            commit('SET_STATE', {
                isCheck,
            });
        },
        async LogOut(state, type = 'remote') {
            if (type === 'remote') {
                await loginApis.logOut();
            }
            authUtils.removeToken();
            window.location.reload();
        },

        /**
         * CATEGORY 分类下所属菜单, 数组元素对应返回的菜单一级节点
         */
        async GetJurisdiction({ commit, state }) {
            try {
                const data = state.userMenuTree;
                const resArr = {};

                data.forEach((item) => {
                    Object.keys(routerCategoryMap).forEach((categoryName) => {
                        if (routerCategoryMap[categoryName].includes(item.name)) {
                            if (resArr[categoryName]) {
                                resArr[categoryName].push(item);
                            } else {
                                resArr[categoryName] = [
                                    item,
                                ];
                            }
                        }
                    });
                    // for (const categoryName in routerCategoryMap) {
                    //     if (routerCategoryMap[categoryName].includes(item.name)) {
                    //         if (resArr[categoryName]) {
                    //             resArr[categoryName].push(item);
                    //         } else {
                    //             resArr[categoryName] = [
                    //                 item,
                    //             ];
                    //         }
                    //     }
                    // }
                });
                commit('SET_STATE', {
                    userMenuList: resArr,
                });
            } catch (err) {
                throw new Error(err);
            }
        },
    },
};

export default user;
